// @flow
/* eslint-disable import/prefer-default-export */
export const UPDATE_STOCK_FOR_STOCK_ITEMS: 'UPDATE_STOCK_FOR_STOCK_ITEMS' =
  'UPDATE_STOCK_FOR_STOCK_ITEMS';
export const ALLOCATE_STOCK_FOR_STOCK_ITEMS: 'ALLOCATE_STOCK_FOR_STOCK_ITEMS' =
  'ALLOCATE_STOCK_FOR_STOCK_ITEMS';
export const CLEAR_ALLOCATIONS: 'CLEAR_ALLOCATIONS' = 'CLEAR_ALLOCATIONS';
export const CLEAR_CONSTRAINED_ALLOCATIONS: 'CLEAR_CONSTRAINED_ALLOCATIONS' =
  'CLEAR_CONSTRAINED_ALLOCATIONS';
export const CLEAR_INVENTORY: 'CLEAR_INVENTORY' = 'CLEAR_INVENTORY';
